import type * as React from 'react'

import { cn } from '@/shared/lib/cn'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content min-h-16 w-full border bg-card [border-color:var(--control-field-border)] [border-radius:var(--control-field-radius)] [padding:var(--control-field-textarea-padding)] [font-family:var(--control-font-family)] [font-size:var(--control-field-font-size)] [font-weight:var(--control-field-font-weight)] [line-height:var(--control-field-line-height)] shadow-none transition-[color,border-color,box-shadow] outline-none placeholder:[color:var(--control-field-placeholder)] placeholder:[opacity:var(--control-field-placeholder-opacity)] hover:[border-color:var(--control-field-hover-border)] focus-visible:[border-color:var(--control-field-focus-border)] focus-visible:[box-shadow:var(--control-field-focus-shadow)] disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
